import { defineNuxtRouteMiddleware, useRuntimeConfig } from "nuxt/app";
import { appLogger } from "@/services/AppLogger";

export default defineNuxtRouteMiddleware(async (to) => {
  // skip middleware on server
  if (process.server) {
    return;
  }

  const config = useRuntimeConfig();
  const isPageViewTrackingEnabled = String(config.public.isPageViewTrackingEnabled).toLowerCase();

  if (!isPageViewTrackingEnabled || isPageViewTrackingEnabled === 'false') {
    return;
  }

  appLogger.logPageView(
    to.name as string, 
    {
      pageName: to.name as string,
      path: to.path,
      fullPath: to.fullPath,
      query: to.query ? JSON.stringify(to.query) : '',
      redirectedFrom: to.redirectedFrom ? to.redirectedFrom.fullPath : '',
    });

  return;
});